import { useState } from "react";
import { Badge, Button } from "react-bootstrap";
import JSONData from "../JSONData/JSONData";
import { ConfirmModal } from "../Modals/confirmModal";
import { VrboAction } from "./useVrboAction";

export default function VrboActionRow(
    props: {
        action: VrboAction
        label: string
        busyLabel: string
        resultTitle: string
        variant?: string
        disabled?: boolean
        // replaces the default click behavior (e.g. to open a modal that collects input before running the action)
        onClick?: () => void
        confirm?: {
            title: string
            message: string
        }
    }
) {
    const {
        action,
        label,
        busyLabel,
        resultTitle,
        variant = 'primary',
        disabled = false,
        onClick,
        confirm,
    } = props

    const [isConfirming, setIsConfirming] = useState(false)

    const handleClick = () => {
        if (onClick) {
            onClick()
            return
        }
        if (confirm) {
            setIsConfirming(true)
            return
        }
        action.run()
    }

    return (
        <div className="mb-3">
            <div className="d-flex align-items-center gap-2">
                <Button
                    size="sm"
                    variant={variant}
                    onClick={handleClick}
                    disabled={action.isLoading || disabled}
                >
                    {action.isLoading ? busyLabel : label}
                </Button>
                {action.status === 'success' && (
                    <Badge bg="success">Success</Badge>
                )}
                {action.status === 'error' && (
                    <Badge bg="danger">Error</Badge>
                )}
                {action.completedAt && (
                    <small className="text-muted">{action.completedAt.toLocaleTimeString()}</small>
                )}
            </div>

            {action.status !== 'idle' && (
                <div className="mt-2">
                    <JSONData data={action.result} title={resultTitle} onClose={action.clear} />
                </div>
            )}

            {confirm && (
                <ConfirmModal
                    active={isConfirming}
                    title={confirm.title}
                    message={confirm.message}
                    onClose={() => setIsConfirming(false)}
                    onConfirm={() => {
                        setIsConfirming(false)
                        action.run()
                    }}
                />
            )}
        </div>
    )
}
